export default "__VITE_PUBLIC_ASSET__3b9a16c0__"